export default __webpack_public_path__ + "static/media/hht1_ep12_minisitcom_02.b6251cfd.png";